import { noticesReducer } from 'store/notices'
import { testDrivesReducer } from 'store/testDrives'
import { contactsReducer } from 'store/contacts'

export default (state = {}, action) => ({
  ...state,

  notices: noticesReducer(state.notices, action),
  testDrives: testDrivesReducer(state.testDrives, action),
  contacts: contactsReducer(state.contacts, action)
})



// WEBPACK FOOTER //
// ./src/store/index.js